<template>
  <van-nav-bar
    title="学生公寓自助选床须知"
    left-text="返回"
    left-arrow
    @click-left="onClickLeft"
  />
  <div class="el-div">
    <p v-html="info.dataread.description"></p>
  </div>

  <div>
    <div id="countdown">
      <button
        class="button"
        :class="{ disabled: !info.canClick }"
        @click="countDown"
      >
        {{ info.content }}
      </button>
    </div>
  </div>
</template>
 
 <script>
import { reactive } from "vue";
import { getInfoBaseByType } from "../../http/api.ts";
import { GetWebSiteSet } from "../../http/api.ts";
import { getTime } from "../../http/api.ts";
import { Dialog } from "vant";

import Route from "../../router/index";
export default {
  setup() {
    let info = reactive({
      dataread: "",
      datasetnumber: 0,
      content: "倒计时开始...",
      totalTime: 10,
      canClick: false,
    });
    let dataFun = async () => {
      await getInfoBaseByType("10").then((res) => {
        info.dataread = res.datas;
      });
    };
    let dataSet = async () => {
      await GetWebSiteSet().then((res) => {
        info.datasetnumber = res.datas.number + 1;
      });
    };
    let settime = () => {
      info.canClick = false;
      //info.content = "请仔细阅读选床须知（" + info.datasetnumber + "s）";
      let clock = setInterval(() => {
        info.datasetnumber--;
        info.content = "请仔细阅读选床须知（" + info.datasetnumber + "s）";
        if (info.datasetnumber < 0) {
          window.clearInterval(clock);
          info.content = "已阅读，开始选床位";
          info.canClick = true;
        }
      }, 1000);
    };
    dataSet();
    dataFun().then(() => {
      settime();
    });
    return { info };
  },
  methods: {
    countDown() {
      if (this.info.canClick) {
        getTime().then((res) => {
          if (res.datas) {
            Route.push("/m/studentinfo?tmsite="+Math.random());
          } else {
            Dialog.alert({
                    title: '提示',
                    message: res.msg
                    ,allowHtml:true
                  });
          }
        });
      }
    },
    onClickLeft() {
      history.go(-1);
    },
  },
};
</script>
<style scoped>
#countdown {
  margin: 10px 0;
}
.el-div {
  text-align: left;
  width: calc(100% - 40px);
  margin: 0 auto;
  padding: 0 20px;
}
.button {
  color: #fff;
  background: #059490;
  cursor: pointer;
  border: 1px solid #dcdfe6;
  border-color: #dcdfe6;
  text-align: center;
  font-weight: 500;
  padding: 7px 20px;
  font-size: 14px;
  border-radius: 4px;
}
.disabled {
  background-color: #ddd;
  border-color: #ddd;
  color: #57a3f3;
  cursor: not-allowed;
}
</style>